import { render, staticRenderFns } from "./CustomerApplication.vue?vue&type=template&id=1ea85846&scoped=true&"
import script from "./CustomerApplication.vue?vue&type=script&lang=js&"
export * from "./CustomerApplication.vue?vue&type=script&lang=js&"
import style0 from "./CustomerApplication.vue?vue&type=style&index=0&id=1ea85846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea85846",
  null
  
)

export default component.exports